<script>

const BASE_URL = "https://chemyang.ccnu.edu.cn/api" + "/";
const BASE_URL_ZS = "https://chemyang.ccnu.edu.cn/api" + "/";

const PIC_URL = "http://localhost:8080";
const PIC_FWB_URL = "https://chemyang.ccnu.edu.cn/api" + "/uploads/";


//建议压缩时的判断尺寸小于上传的大小
const contractionSize = '2';
const PIC_URLSize = '2';

//部署服务器位置
const BASE_XUEHUI_URL = "https://chemyang.ccnu.edu.cn";
// const BASE_XUEHUI_URL = "https://chemyang.ccnu.edu.cn";

// const BASE_URL = "http://dev.xhaitech.com/www/ktz/";
// const BASE_URL_ZS = "http://dev.xhaitech.com/www/ktz/";
// const PIC_URL = "http://localhost:8080";
// // const PIC_FWB_URL = "https://ktz.yuhoutech.com/example/api/uploads/";
// const PIC_FWB_URL = "http://dev.xhaitech.com/www/ktz/uploads/";

// //部署服务器位置
// const BASE_XUEHUI_URL = "http://dev.xhaitech.com/ysh/ktz/html";
//个人主页用
const link_member = BASE_XUEHUI_URL + "/#/member/";
//后台管理基础路径
const HT_BASE = BASE_XUEHUI_URL + "/ht/#";
//首页
const HT_INDEX_ = HT_BASE + "/index";
//首页配置
const HT_INDEX_CONFIG_ = HT_BASE + "/indexConfig";
//团队介绍
const HT_TEAM_ = HT_BASE + "/teamIntroduce";
//底部配置
const HT_FOOTER_ = HT_BASE + "/footerConfig";
const fileSize ="20";
// 设备管理
const HT_Equipment_ = HT_BASE + "/researchEquipment";
// 科研项目
const HT_Project = HT_BASE + "/researchProject";

// 研究进展
const HT_Progress = HT_BASE + "/researchProgress";

//团队介绍
const HT_teamIntroduce = HT_BASE + "/teamIntroduce";

//动态管理
const HT_dynamicManagement = HT_BASE + "/dynamicManagement";
//课题组介绍
const HT_researchIntroduce = HT_BASE + "/researchIntroduce";
//研究方向
const HT_researchDirection = HT_BASE + "/researchDirection";
//后台头部
const HT_headConfig = HT_BASE + "/headConfig";

/**个人中心 */
const ZX_BASE = BASE_XUEHUI_URL + "/zx/#";
//首页
const ZX_INDEX_ = ZX_BASE + "/dashboard";
//成果
const ZX_PROGRESS_ = ZX_BASE + "/researchProgress";
//科研项目
const ZX_project_ = ZX_BASE + "/project";

export default {
  BASE_URL,
  BASE_URL_ZS,
  PIC_URL,
  HT_INDEX_,
  HT_INDEX_CONFIG_,
  HT_TEAM_,
  ZX_INDEX_,
  ZX_PROGRESS_,
  HT_FOOTER_,
  HT_Equipment_,
  HT_Project,
  HT_Progress,
  HT_teamIntroduce,
  HT_dynamicManagement,
  HT_researchIntroduce,
  HT_researchDirection,
  HT_headConfig,
  ZX_project_,
  HT_BASE,
  ZX_BASE,
  PIC_FWB_URL,
  link_member,
  fileSize,
  contractionSize,
  PIC_URLSize
};
</script>




// WEBPACK FOOTER //
// src/utils/Global.vue